module.exports = __webpack_public_path__ + "static/media/Help.1b5dbc1b.png";